module.exports = {"password":"密码必须至少 6 个字符，并与确认匹配。","reset":"您的密码已重置！","sent":"我们已经通过电子邮件发送了您的重置密码链接！","token":"此密码重置令牌无效。","user":"我们无法找到拥有该电子邮箱地址的用户。"};